import {
    STORE_TYPE_BITRIX,
    STORE_TYPE_KIT,
    STORE_TYPE_LITE,
    STORE_TYPE_REMOTE_ORM,
    STORE_TYPE_YCP,
} from '#shared/lib/const';
import { getSafeStoreInfoRequestContext } from '#shared/lib/context';
import { type StoreType } from '#shared/lib/storeInfo';
import { BITRIX_MENU_CONFIGURATION } from '../menuConfigurations/bitrix';
import { KIT_MENU_CONFIGURATION } from '../menuConfigurations/kit';
import { LITE_MENU_CONFIGURATION } from '../menuConfigurations/lite';
import { YCP_MENU_CONFIGURATION } from '../menuConfigurations/ycp';
import { type MenuConfiguration } from '../types';

const MENU_CONFIGURATION_BY_STORE_TYPE = {
    [STORE_TYPE_KIT]: KIT_MENU_CONFIGURATION,
    [STORE_TYPE_REMOTE_ORM]: KIT_MENU_CONFIGURATION,
    [STORE_TYPE_YCP]: YCP_MENU_CONFIGURATION,
    [STORE_TYPE_BITRIX]: BITRIX_MENU_CONFIGURATION,
    [STORE_TYPE_LITE]: LITE_MENU_CONFIGURATION,
} satisfies Record<StoreType, MenuConfiguration>;

export const getMenuConfiguration = (): MenuConfiguration => {
    const { type } = getSafeStoreInfoRequestContext();
    const configuration = MENU_CONFIGURATION_BY_STORE_TYPE[type];

    if (!configuration) {
        throw new Error(`Menu configuration is not defined for store type: ${type}`);
    }

    return configuration;
};
